export default __webpack_public_path__ + "static/media/71.122ffc8a.png";